import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const usePageTransferStore = defineStore('pageTransfer', ()=>{
  const storageKey = 'pageTransferData'

  const loadFromStorage = () => {
    const storedData = localStorage.getItem(storageKey)
    return storedData ? JSON.parse(storedData) : {
      formConfigData: null,
      formData: null,
      transferData: null,
      currentActivity: null,
      dataOverviewList: null
    }
  }

  // const state = ref(loadFromStorage())
  const formConfigData = ref(loadFromStorage().formConfigData)
  const formData = ref(loadFromStorage().formData)
  const transferData = ref(loadFromStorage().transferData)
  const currentActivity = ref(loadFromStorage().currentActivity)
  const dataOverviewList = ref(loadFromStorage().dataOverviewList)



  // 计算属性（相当于getters）
  const getFormConfigData = computed(() => formConfigData.value)
  const getFormData = computed(() => formData.value)
  const getTransferData = computed(() => transferData.value)
  const getCurrentActivity = computed(() => currentActivity.value)
  const getDataOverviewList = computed(() => dataOverviewList.value)


  const saveToStorage = () => {
    const stateToSave = {
      formConfigData: formConfigData.value,
      formData: formData.value,
      transferData: transferData.value,
      currentActivity: currentActivity.value,
      dataOverviewList: dataOverviewList.value
    }
    localStorage.setItem(storageKey, JSON.stringify(stateToSave))
  }


  function setFormConfigData(data) {
    formConfigData.value = data
    saveToStorage()
  }

  function setFormData(data) {
    formData.value = data
    saveToStorage()
  }

  function setTransferData(data) {
    transferData.value = data
    saveToStorage()
  }

  function setCurrentActivity(activity) {
    currentActivity.value = activity
    saveToStorage()
  }

  function setDataOverviewList(data) {
    dataOverviewList.value = data
    saveToStorage()
  }
  
  function clearData() {
    formConfigData.value = null
    formData.value = null
    transferData.value = null
    currentActivity.value = null
    dataOverviewList.value = null
  }
  
  function clearStorage() {
    localStorage.removeItem(storageKey)
    clearData()
  }


  return {
    // 状态（可以直接访问）
    formConfigData,
    formData,
    transferData,
    currentActivity,
    dataOverviewList,
    
    // 计算属性
    getFormConfigData,
    getFormData,
    getTransferData,
    getCurrentActivity,
    getDataOverviewList,
    
    // Actions
    setFormConfigData,
    setFormData,
    setTransferData,
    setCurrentActivity,
    setDataOverviewList,
    clearData,
    clearStorage
  }

})